import React from "react";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import {
  Datagrid,
  DateField,
  List,
  TextField,
  useStore,
  FunctionField,
  Title,
  ShowButton,
  SimpleList,
  ReferenceField,
} from "react-admin";
import { MOBILE_BREAKPOINT, ThesisDefenseRequestAction, ThesisDefenseRequestStatus } from "utils/constants";
import CustomFilter from "features/CustomFilter";
import useInternshipFilter from "features/filters/useInternshipFilter";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { formatStudentOption } from "../utils";
import RequestDialog from "./components/RequestDialog";
import { graduationRequests } from "api/graduationApi";
import ListActionsToolbar from "./components/ListActionsToolbar";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const STORE_KEY = "thesisDefense.filters";

const ListThesisDefense = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const internship = useInternshipFilter({ filters });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Защита на дипломна работа"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={internship.fields}
        buttonLabel="Покажи"
        buttonDisabled={!internship.isComplete}
        buttonOnClick={() => handleSearch(internship.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за Защита на дипломна работа
            </Typography>
          </Box>
        </Paper>
      ) : (
        <List
          title="Защита на дипломна работа"
          filter={filters}
          exporter={false}
          empty={false}
          actions={<ListActionsToolbar internshipSessionId={filters.internshipSessionId} />}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <div>
                  <MobileListRow fields={[{ label: "Студент", value: formatStudentOption(false)(record) }]} />
                  <MobileListRow
                    fields={[{ label: "Факултетен номер", value: record?.studentInfo?.facultyNumber }]}
                  />
                </div>
              )}
              secondaryText={record => (
                <div>
                  <MobileListRow fields={[{ label: "Държавен изпит", value: record?.stateExamNameBg }]} />
                  <MobileListRow
                    fields={[
                      {
                        label: "Създаден на",
                        value: (
                          <DateField
                            source="createdOn"
                            locales="bg-BG"
                          />
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Статус на заявка",
                        value: (
                          <ReferenceField
                            source="status"
                            reference={graduationRequests.getThesisDefenseRequestStatusesSelect()}
                          >
                            <TextField source="nameBg" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  {record?.status === ThesisDefenseRequestStatus.Pending && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                      <SecuredComponent permission={permissions.canManageThesisDefenseRequests}>
                        <RequestDialog
                          id={record?.id}
                          action={ThesisDefenseRequestAction.Approve}
                        />
                        <RequestDialog
                          id={record?.id}
                          action={ThesisDefenseRequestAction.Reject}
                        />
                      </SecuredComponent>
                    </div>
                  )}
                </div>
              )}
              tertiaryText={() => (
                <SecuredComponent permission={permissions.canPreviewThesisDefenseRequests}>
                  <ShowButton label="" />
                </SecuredComponent>
              )}
            />
          ) : (
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
            >
              <FunctionField
                label="Студент"
                render={formatStudentOption(false)}
                sortable={false}
              />
              <TextField
                source="studentInfo.facultyNumber"
                label="Факултетен номер"
                sortable={false}
              />
              <TextField
                source="stateExamNameBg"
                label="Държавен изпит"
                sortable={false}
              />
              <DateField
                source="createdOn"
                label="Създаден на"
                locales="bg-BG"
                sortable={false}
              />
              <ReferenceField
                source="status"
                reference={graduationRequests.getThesisDefenseRequestStatusesSelect()}
                label="Статус на заявка"
              >
                <TextField source="nameBg" />
              </ReferenceField>

              <SecuredComponent permission={permissions.canPreviewThesisDefenseRequests}>
                <ShowButton />
              </SecuredComponent>
              <FunctionField
                render={rec =>
                  rec?.status === ThesisDefenseRequestStatus.Pending && (
                    <SecuredComponent permission={permissions.canManageThesisDefenseRequests}>
                      <RequestDialog
                        id={rec?.id}
                        action={ThesisDefenseRequestAction.Approve}
                      />
                      <RequestDialog
                        id={rec?.id}
                        action={ThesisDefenseRequestAction.Reject}
                      />
                    </SecuredComponent>
                  )
                }
              />
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListThesisDefense;
